"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewTeamsAppArguments = exports.PreviewTeamsAppOptions = void 0;
exports.PreviewTeamsAppOptions = [
    {
        name: "m365-host",
        type: "string",
        shortName: "m",
        description: "Preview the application in Teams, Outlook or the Microsoft 365 app.",
        required: true,
        default: "teams",
        choices: ["teams", "outlook", "office"],
    },
    {
        name: "teams-manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specify the path for Teams app manifest template. It can be either absolute path or relative path to the project root folder, with default at './appPackage/manifest.json'",
        required: true,
        default: "./appPackage/manifest.json",
    },
];
exports.PreviewTeamsAppArguments = [];
//# sourceMappingURL=PreviewTeamsAppOptions.js.map